import { Unit } from 'sr-types/lib/search/v1/graphql';
import { useUnitsDataLazy } from '../../../../attributes/attributesApi';
import {
    DURATION_UNITS_DATA_FORCE_FETCH_ON_MOUNT,
    DURATION_UNITS_DATA_IDENTIFIER,
    DURATION_UNITS_DATA_PAGE_SIZE
} from '../constants';

export const useGetDurationUnits = (providedDurationUnits?: Unit[]) => {
    const shouldFetch = !providedDurationUnits;

    const { unitsData, unitsLoading, unitsError } = useUnitsDataLazy(
        DURATION_UNITS_DATA_IDENTIFIER,
        shouldFetch ? DURATION_UNITS_DATA_FORCE_FETCH_ON_MOUNT : false,
        DURATION_UNITS_DATA_PAGE_SIZE
    );

    // If provided units are available, use them; otherwise use fetched data
    const durationUnitsData = providedDurationUnits ?? ((unitsData?.results?.hits?.items ?? []) as Unit[]);

    return {
        durationUnitsData,
        isLoadingDurationUnitsData: providedDurationUnits ? false : unitsLoading,
        errorLoadingDurationUnitsData: providedDurationUnits ? undefined : unitsError
    };
};
